<template>
  <div class="page">
    <app-header title="支付" ref="header" v-if="loaded">
      <i class="back" slot="back"></i>
    </app-header>
    <div class="payInfo" v-if="loaded" ref="main">
      <div class="notice center bg_white">
        请在{{ shengyuTime }}内完成支付，超时订单自动取消
      </div>
      <div class="paySum">
        <span class="name">支付金额</span>
        <span><i>￥</i>{{ showFee }}</span>
      </div>
      <div class="payBy">
        <div @click="chooseCoupons" class="payByCenter">
          <div class="flex1">
            <img class="icon" src="../../../../static/img/coupons/coupons-pay.png" alt="">
            <span>礼券</span>
          </div>
          <div class="icon_sp_area flex0">
            <span class="flex0" v-if="count&&coupons&&coupons.desc">{{ this.showCoupon }}&nbsp;&nbsp;</span>
            <span class="flex0" v-else>{{ count == 0 ? '暂无可用优惠券' : count + '张可用优惠券' }}&nbsp;&nbsp;</span>
            <img class="flex1" src="../../../../static/img/arrow.png" alt="">
          </div>
        </div>
      </div>
      <div class="payBy">
        <ul class="bg_white">
          <li v-for="(way,index) in payWay" class="flex pl15 pr15 flex-center" v-if="$brower===way.brower">
            <span class="iconfont fs30 flex0" :class="[way.brower]" v-html="way.icon"></span>
            <span class="ml10 flex1">{{ way.name }}</span>
            <span class="flex0" :class="[confirmPay?'weui-icon-success':'weui-icon-circle']"></span>
          </li>
        </ul>
      </div>
      <div class="confirmPay">
        <div class="confirmCenter">
          <van-button type="info" @click="goSuccess">确认支付</van-button>
        </div>
      </div>
    </div>
    <toast v-if="showToast"></toast>
    <div v-if="$brower==='alipay'" v-html="returnInfo"></div>
  </div>
</template>
<script>
import header from "../../../base/header"
import api from '../../../lib/api'
import Toast from '../../../base/test'
import weuijs from 'weui.js'
import {formatTime} from "@/lib/filter";
import {couponsCache, openidCache} from '@/lib/cache'
import {isBindMixin, mainHeightMixin, toPayPageMixin} from "@/lib/mixin";
import AppHeader from '../../../plugins/app-header'
import {MAIN_COLOR, PAY_WAY} from "@/lib/config";
import {systemService} from "@/services/system";
import {Dialog} from "vant";
import {
  getClientToken,
  getParamsFromUrl,
  isEmpty, isWeixin,
  makeToken,
  makeUrl,
  needRepeatLogin,
  parsePayErrMsg, queryStrBuilder
} from "@/lib/util";
import {consultService} from "@/services/consult";
import {ncpService} from "@/services/ncp";
import {userService} from "@/services/user";
import {directGetOpenId} from "@/lib/auth2";
import {VERSION5_3_0} from "@/lib/version";
import {OkHttp} from "@/services/base";
import {cancelPayToPageEvent} from "@/lib/cancelPayToPage";

function createFactory() {
  if (VERSION5_3_0) {
    return async function () {
      this.consultId = this.$route.query.consultId;
      this.canJumpto = false;
      let err_msg = parsePayErrMsg(this.$route.query.err_msg);
      if (err_msg === 'ok') {
        this.canJumpto = true;
        this.success();
      } else {
        const {code, ...user} = await userService.get();
        if (code && needRepeatLogin(code)) {
          this._redirectPreLogin();
        } else {
          await this.initDetail(user)
        }
      }
    }
  } else {
    return async function () {
      let coupons = couponsCache.get();
      coupons && (this.coupons = coupons);
      this.consultId = this.$route.query.consultId
      const token = this.get.token
      const openid = this.$route.query.openid
      const {channel} = this.query;
      const config = await systemService.channelDetails(channel);
      let err_msg = parsePayErrMsg(this.$route.query.err_msg);
      if (err_msg === 'ok') {
        this.canJumpto = true;
        this.success();
      } else if ((this.$brower === 'alipay' || (config.appid === this.env.weixinPay))) {
        const {code, ...user} = await userService.get();
        if (code && needRepeatLogin(code)) {
          this._redirectPreLogin();
        } else {
          if (token) {
            if (openid) await this.initDetail(user);
            else directGetOpenId(config.appid);
          } else {
            await this.initDetail(user);
          }
        }

      } else {
        if (this.$brower !== 'alipay') {
          const {obj: payChannelInfo} = await systemService.appidDetails(this.env.weixinPay);
          let options = getParamsFromUrl(location.href);
          Log('options', options);
          //options.query.token = makeToken();
          options.query.channel = payChannelInfo.channel;
          options.hash += '&comefrom=' + encodeURIComponent(location.href) + '&token=' + getClientToken().token;
          const redirectUrl = makeUrl(options);
          Log('redirectUrl', redirectUrl);
          location.replace(redirectUrl);
        }
      }
    }
  }
}

export default {
  data() {
    return {
      loaded: false,
      canJumpto: false,
      info: {},
      payWay: PAY_WAY,
      payWaitSeconds: 0,
      title: "支付",
      confirmPay: true,
      rightTitle: "",
      consultId: "",
      aboutConsult: {},
      count: 0,
      aboutConsultFee: "",
      returnInfo: "",
      appId: "",
      timeStamp: "",
      nonceStr: "",
      package: "",
      signType: "",
      paySign: "",
      showToast: false,
      coupons: {},
      shengyuTime: "",
      timer: null,
      query: url('?'),
      user: {}
    }
  },
  computed: {
    showFee() {
      let fee = parseFloat(this.aboutConsultFee) || 0;
      fee = fee * 100;
      if (Object.keys(this.coupons).length > 0) {
        let reductionMoney = this.coupons.reductionMoney;
        switch (this.coupons.couponType) {
          case 'FULL_REDUCTION_COUPON':
          case 'DIRECT_REDUCTION_COUPON':
            fee = fee - reductionMoney;
            break;
          case 'DISCOUNT_COUPON':
            fee = fee * reductionMoney / 100;
            break;
        }
      }
      fee = fee / 100;
      fee = Math.max(0, fee);
      return fee.toFixed(2);
    },
    showCoupon() {
      if (!this.coupons || Object.keys(this.coupons) == 0) {
        return '';
      }
      let fee = this.coupons.reductionMoney;
      switch (this.coupons.couponType) {
        case 'FULL_REDUCTION_COUPON':
        case 'DIRECT_REDUCTION_COUPON':
          fee = "￥" + fee / 100;
          break;
        case 'DISCOUNT_COUPON':
          fee = (fee / 10) + '折';
          break;
      }
      return fee;
    }
  },
  created: createFactory(),
  beforeRouteLeave(to, from, next) {
    Log('to,from,next', to, from, next);
    const consultId = this.$route.query.consultId
    const args = {
      path: '/team/consult/' + consultId
    }

    if (this.canJumpto) next();
    else if (to.fullPath.startsWith('/team/consult/')) {
      next();
    } else Dialog.confirm({
      title: '确定不支付吗？',
      message: '您的订单已经生成，15分钟不支付会自动取消。',
      confirmButtonColor: MAIN_COLOR,
      confirmButtonText: '继续支付',
      cancelButtonText: '暂不支付'
    }).then(() => {
      next(false);
    }).catch(() => {
      next(args);
      //bus.$emit(cancelPayToPageEvent, {...args})
    })
  },
  beforeDestroy() {
    couponsCache.set({})
    this.clear();
  },
  methods: {
    async initDetail(user) {
      this.user = user;
      await this.getDetail();
      this.needDjs();
    },
    success() {
      couponsCache.set(null);
      this.$router.replace({
        path: '/allConsultSuccess',
        query: {consultId: this.consultId}
      })
    },

    needDjs() {
      let delta = this.payWaitSeconds;
      if (!delta) {
        setTimeout(this.needDjs, 1000);
      } else {
        if (delta > 0) {
          this.djs(delta * 1000);
        }
      }
    },

    djs(t) {
      if (t < 0) {
        this.canJumpto = true;
        this.$router.replace(`/team/consult/` + this.consultId);
        //this.cancel();
      } else {
        this.shengyuTime = formatTime(t, '%M分%S秒');
        this.clear();
        this.timer = setTimeout(() => {
          this.djs(t - 1000)
        }, 1000);
      }
    },

    back() {
      weuijs.confirm("您的订单已经生成，15分钟不支付会自动取消。", {
        title: "确定不支付吗？",
        buttons: [
          {
            label: "暂不支付", type: 'default', onClick: () => {
              let {query} = this.$route;
              if (query && query.consultId) {
                this.$router.replace('/team/consult/' + query.consultId);
              } else this.$router.go(-1);
              /*let {query} = this.$route;
              if (query && query.back && query.back == 'list') {
                this.$router.go(-1);
              } else if (this.aboutConsult.consultType == "DOCPIC") {
                this.$router.go(-3);
              } else {
                this.$router.go(-2);
              }*/
            }
          },
          {
            label: "继续支付", type: 'primary', onClick: () => {
            }
          }
        ]
      })
    },

    clear() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },

    chooseCoupons() {
      let {consultType: currentService, consultFee: payMoney} = this.aboutConsult;
      this.count > 0 && (this.$router.push({
        path: '/coupons/select',
        query: {currentService, payMoney}
      }));
    },

    async cancel() {
      let loading = weuijs.loading("加载中...");
      let ret = await api('nethos.consult.info.cancel', {
        consultId: this.consultId
      });
      if (ret.code == 0) {
        weuijs.toast('超出支付时间，订单自动取消', {
          callback: () => {
            //this.$emit('cancel');
            this.$router.replace(`/team/consult/` + this.consultId);
          }
        })
      }
      loading.hide();
    },

    async getCouponsCount() {
      let loading = weuijs.loading("加载中...");
      let {consultType: currentService, consultFee: payMoney} = this.aboutConsult;
      payMoney = Math.round(payMoney * 100);
      let ret = await api("smarthos.coupon.mycoupon.unused.count", {payMoney, currentService});
      this.count = ret.obj;
      loading.hide();
      if (this.count == 0) this.coupons = {};
    },

    async getDetail() {
      const {query} = this.$route;
      const obj = await consultService.detail(query.consultId);
      this.info = obj;
      const {consult = {}} = obj;
      if (consult.consultType === "RENEWAL_OF_CONSULTATION") {
        this.canJumpto = true;
        return this.handlerRenewal();
      }
      if (!isEmpty(obj)) {
        this.payWaitSeconds = obj.payWaitSeconds;
        this.aboutConsult = consult;
        this.aboutConsultFee = consult.consultFee
      }
      await this.getCouponsCount();
      this.loaded = true;
      this.$nextTick(() => {
        this._calcMainHeight();
      })
    },

    async handlerRenewal() {
      const list = await ncpService.queryOrderByConsultId({
        consultId: this.consultId
      });
      const data = list[0];
      const {consult = {}} = this.info;
      this.$router.replace({
        path: '/butler/mz/dzf',
        query: {
          "patId": consult.patId,
          "compatId": consult.compatId,
          "compatMedicalRecord": consult.compatMedicalRecord,
          "compatIdcard": '',
          "compatRecord": data.bookCard,
          "compatName": "",
          "hosid": data.hosId
        }
      })
    },

    async doWeixinPay() {
      let that = this;
      let conf = {
        "appId": this.returnInfo.appid,     //公众号名称，由商户传入
        "timeStamp": this.returnInfo.time_stamp,         //时间戳，自1970年以来的秒数
        "nonceStr": this.returnInfo.nonce_str, //随机串
        "package": `prepay_id=${this.returnInfo.prepay_id}`,
        "signType": "MD5",         //微信签名方式：
        "paySign": this.returnInfo.pay_sign //微信签名
      }
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        conf,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            that.canJumpto = true;
            let {comefrom} = that.$route.query;
            if (comefrom) {
              comefrom += '&err_msg=ok';
              location.replace(comefrom);
            } else that.success();
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            console.log("支付过程中用户取消")
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            console.log("支付失败")
            weuijs.alert(JSON.stringify(res))
          }
        }
      );
    },

    async doAliPay() {
      this.returnInfo = this.returnInfo.replace(/<script([^>]+)?>([^<]+)?<\/script>/g, '');
      this.$nextTick(() => {
        document.forms[0].submit();
      });
    },


    async newGoSuccess(args) {
      if (isWeixin()) {
        // 是否是有支付权限的公众号
        if (this.appid === this.env.weixinPay) {
          args.openid = openidCache.get();
          if (!args.openid) {
            this.canJumpto = true;
            return this._redirectPreLogin();
          }
          const {code, obj, msg} = await OkHttp.$http('nethos.consult.info.pay', args);
          if (code === '0') {
            try {
              this.returnInfo = JSON.parse(obj);
              await this.doWeixinPay();
            } catch (e) {
              bus.$emit('msg', '支付字符串错误');
            }
          } else {
            bus.$emit('msg', msg);
          }
        } else {
          await this.toPayPage(args)
        }
      } else {
        bus.$emit('msg', '目前只支持在微信内支付');
      }
    },

    async goSuccess() {
      const openid = this.$route.query.openid
      if (!this.confirmPay) {
        weuijs.alert('请选择支付方式');
        return
      }

      // location.href=`http://weixin.diandianys.com/wxpay/pay.html?back=${encodeURIComponent("https://nethosweb.diandianys.com/wechat/#/blankPage/"+this.consultId)}&amount=${(this.aboutConsultFee)*100}&obj=${this.consultId}`
      let that = this
      this.showToast = true
      let opts = {
        consultId: this.consultId,
        returnUrl: encodeURIComponent(location.origin + location.pathname + location.search + '#/allConsultSuccess?consultId=' + that.consultId),
        payChannel: "WECHAT"
      };

      if (that.coupons && that.coupons.desc) {
        opts.myCouponId = that.coupons.id;
      }

      if (VERSION5_3_0) {
        opts.okCallback = encodeURIComponent(location.href);
        opts.cancelCallback = opts.okCallback;
        opts.failCallback = opts.cancelCallback;
        return this.newGoSuccess(opts);
      }

      opts.token = that.$route.query.token || null;
      opts.openid = openid || openidCache.get();
      let data = await api("nethos.consult.info.pay", opts);
      this.showToast = false
      if (data.code == 0 && data.obj) {
        if (data.obj.toUpperCase() == 'SUCCESS') {
          that.$router.replace({
            path: '/allConsultSuccess',
            query: {consultId: that.consultId}
          });
          return
        }
        if (that.$brower === 'weixin') {
          this.returnInfo = JSON.parse(data.obj);
          await that.doWeixinPay();
        } else if (that.$brower === 'alipay') {
          return that.modalAliapy();
          //this.returnInfo = data.obj;
          //that.doAliPay();
        }
      } else if (data.code == -2 && data.msg == '当前订单已支付') {
        weui.alert('当前订单已支付')
      } else if (data.code == 0 && !(data.obj)) {
        if (that.$brower === 'alipay')
          return that.modalAliapy();
      } else {
        this.$weuijs.alert(data.msg);
      }
    },
    toPayPage(args) {
      this.canJumpto = true;
      this._toPayPage('nethos.consult.info.pay', args);
    }
  },
  components: {
    "VHeader": header,
    Toast,
    AppHeader
  },
  mixins: [toPayPageMixin, mainHeightMixin, isBindMixin]
}
</script>
<style scoped lang="scss">
@import '../../../common/public.scss';

.weui-icon-success {
  color: $mainColor;
}

.notice {
  @include h_lh(50px);
}

.page {
  background-color: #F8F8F8;
}

.payInfo {
  .paySum {
    width: 100%;
    height: px2rem(230px, 750);
    display: flex;
    background-color: white;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span:first-child {
      font-size: px2rem(32px, 750);
      color: #f4888c;
    }

    span:last-child {
      i {
        font-style: normal;
        font-size: px2rem(36px, 750);
      }

      font-size: px2rem(72px, 750);
      color: #f4888c;
    }

  }

  .payMethod {
    height: 80rem/$rem;
    font-size: 28rem/$rem;
    color: #666666;
    background-color: rgb(245, 245, 245);
  }

  p {
    margin: 0;
    padding-left: 30rem/$rem;
    height: 50px;
    line-height: 50px;
  }

  .payBy {
    margin-top: 10px;
    background-color: white;
    width: 100%;
    height: 50px;

    ul {
      li {
        @include h_lh(px2rem(50px));
      }
    }

    .weixin {
      color: #0BB20C;
    }

    .alipay {
      color: #0aace9;
    }

    .payByCenter {
      width: 690rem/$rem;
      height: 50px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .icon_sp_area {
        span, img {
          display: block;
        }

        span {
          color: #999;
        }

        img {
          height: 15px
        }
      }

      > div {
        display: flex;
        align-items: center;

        span {
          font-size: 32rem/$rem;
          color: #333333;
        }

        img.icon {
          margin-right: 5px;
          width: 50rem/$rem;
        }
      }
    }
  }

  .confirmPay {
    width: 100%;
    height: 80rem/$rem;
    margin-top: 50px;

    .confirmCenter {
      width: 690rem/$rem;
      margin: 0 auto;
    }

    button {
      width: 690rem/$rem;
      border: none;
      outline: medium;
      height: 80rem/$rem;
      border-radius: 7px;
      color: white;
      font-size: 32rem/$rem;
      background-color: $mainColor;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/index/doctorVideo/videoPay.vue